import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const ButtonContainer = styled.div`
  position: relative;
`

export const buttonProgress = css`
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -12px;
  margin-left: -12px;
`

export const content = css`
  min-width: 600px;
`
